import { useQuery as useRQQuery } from 'react-query';

export const useQuery = useRQQuery;
